import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonNotificationObject } from '../types';
import { INotificationAttrs } from '../../AppComponents/Notifications/types';

interface IJoinChannelNotificationsReducerState extends Record<string, any> {
  notificationAttrs: INotificationAttrs;
  notification: CommonNotificationObject;
}

export const initialState: IJoinChannelNotificationsReducerState = {
  notification: {},
  notificationAttrs: {} as INotificationAttrs,
};

const joinChannelNotificationsSlice = createSlice({
  name: 'joinChannelNotifications',
  initialState,
  reducers: {
    changeJoinChannelNotification(
      state,
      action: PayloadAction<CommonNotificationObject>,
    ) {
      state.notification = action.payload;

      if (Object.keys(state.notificationAttrs).length <= 0) {
        state.notificationAttrs = {
          mainLoad: 0,
          failed: false,
          fullyComplete: false,
        };
      }
    },
    changeJoinChannelNotificationAttrs(
      state,
      action: PayloadAction<Record<keyof INotificationAttrs, any>>,
    ) {
      state.notificationAttrs = {
        ...state.notificationAttrs,
        ...action.payload,
      };
    },
    clearJoinChannelNotifications() {
      return initialState;
    },
  },
});

export const {
  changeJoinChannelNotification,
  clearJoinChannelNotifications,
  changeJoinChannelNotificationAttrs,
} = joinChannelNotificationsSlice.actions;

export default joinChannelNotificationsSlice.reducer;
